module.exports = __webpack_public_path__ + "static/media/person_add-24px.e2e823d0.svg";